<div>
  <hub-modal-header headerText="{{ 'bikeshop.pos_products.add_to_collection' | translate }}"
    [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">
  <!-- Existing collections: same layout as the job card's "Save to a collection" -->
  <div class="collections-container">
    <div>
      <div *ngFor="let collection of collections" [ngClass]="{'disabled': isCurrentCollection(collection)}">
        <div>
          <div class="collection-badge">{{ collection.count }}</div>
          <div>{{ collection.collectionName }}</div>
        </div>
        <div>
          <hub-button [size]="'md'" [icon]="'chevron-right'" [style]="'outline'"
            [disabled]="isCurrentCollection(collection) || saving"
            (buttonClick)="addToCollection(collection)"></hub-button>
        </div>
      </div>
    </div>
  </div>

  <!-- New collection -->
  <div class="jobcard-label">{{ 'bikeshop.pos_products.create_new_collection' | translate }}</div>
  <hub-input [(ngModel)]="newCollectionName" (ngModelChange)="errorMessage = ''"
    placeholder="{{ 'bikeshop.pos_products.collection_name' | translate }}"></hub-input>
  <div class="red" *ngIf="errorMessage">{{ errorMessage }}</div>
</div>

<div class="modal-footer-container">
  <div class="button-container">
    <hub-button [text]="'bikeshop.workshop.jobcard.quote.create_a_collection' | translate" [style]="'secondary'"
      [size]="'xl'" [disabled]="!canCreate()" [loading]="saving" (buttonClick)="createAndAdd()"></hub-button>
  </div>
</div>